export {SETTINGS_PAGES, SettingsView} from 'src/SettingsView/SettingsView';
